"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getTenant_1 = __importDefault(require("../utils/getTenant"));
const constant_1 = require("../constants/constant");
const dataTypes_1 = require("../constants/dataTypes");
const clientIsShopeeApp_1 = __importDefault(require("./clientIsShopeeApp"));
function goToLogin() {
    if (clientIsShopeeApp_1.default()) {
        const redirectPath = getAppPath(window.location.href);
        WebViewJavascriptBridge.callHandler("login", { redirectTab: dataTypes_1.E_REDIRECT_TAB.LOGIN, redirectPath }, (res) => {
            if (res.status === dataTypes_1.E_STATUS.SUCCESS) {
                window.location.reload();
            }
        });
    }
    else {
        const redirectPath = getWebPath(window.location.href);
        window.location.href = redirectPath;
    }
}
exports.goToLogin = goToLogin;
function getAppPath(url) {
    const a = { paths: [{ webNav: { url } }] };
    const b = btoa(JSON.stringify(a));
    return "home?navRoute=" + encodeURIComponent(b);
}
function getWebPath(url) {
    const tenant = getTenant_1.default();
    const domain = constant_1.DOMAIN_BY_TENANT[tenant];
    const hostPrefix = getHostPrefix(url);
    return `${hostPrefix}${domain}/buyer/login?next=${encodeURIComponent(url)}`;
}
function getHostPrefix(url) {
    let env;
    if (url.includes("test.") || !url.includes("shopee"))
        env = 'test';
    else if (url.includes("uat."))
        env = 'uat';
    else
        env = 'production';
    return constant_1.HOST_PREFIX_BY_ENV[env];
}
//# sourceMappingURL=utils.js.map